export const SIZE_GRADE_OPTIONS = [
  { value: '20-30', label: '20-30 (Jumbo)' },
  { value: '31-40', label: '31-40 (Extra Large)' },
  { value: '41-50', label: '41-50 (Large)' },
  { value: '51-60', label: '51-60 (Medium)' },
  { value: '61-70', label: '61-70 (Small)' },
  { value: '71-90', label: '71-90 (Tiny)' },
  { value: 'mixed', label: 'Mixed' },
];
